import { useNavigate } from "react-router-dom";
import { HOME_PATH } from "../routes";

export default function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div className="empty">
      <h2>Page not found</h2>
      <p>The page you’re looking for doesn’t exist.</p>
      <button type="button" className="cat active" onClick={() => navigate(HOME_PATH)}>
        Back to shop
      </button>
    </div>
  );
}
